module.exports = __webpack_public_path__ + "static/media/left_output.3a590bd5.png";